import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { DEFAULT_THEME } from '../../theming';
export const HDSAppProvider = ({
  children
}) => {
  // @ts-expect-error - Prevents downstream builds from failing
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: DEFAULT_THEME,
    children: children
  });
};